<template>
  <div class="enterpriseedit">
    <div class="flex-center title" v-html="type == 1 ? '第三方企业认证' : '企业认证'"></div>

    <div class="jie_guo" v-if="data">
      <div class="flex-center biao_ti">审批结果</div>
      <div>
        <span v-if="data.status == 0">审核中</span>
        <span v-else-if="data.status == 1">已通过</span>
        <span v-else-if="data.status == 2">未通过</span>
        :
        {{ data ? data.checkRemark : "" }}
      </div>
    </div>
    <!-- 新增修改表单 -->
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" v-if="etype != 1">
      <el-form-item label="营业执照">
        <el-upload class="upload-demo" drag :action="burl + '/api/v1/upload'" multiple :show-file-list="false"
          :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload" :on-progress="handleProgress"
          v-loading="loading">
          <div v-if="!form.imageUrl">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将营业执照拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">大小不能超过20m</div>
          </div>
          <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar" />
        </el-upload>
      </el-form-item>

      <el-form-item label="企业logo">
        <el-upload class="upload-demo" drag :action="burl + '/api/v1/upload'" multiple :show-file-list="false"
          :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2" :on-progress="handleProgress2"
          v-loading="loading2">
          <div v-if="!form.logo">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将企业logo拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">大小不能超过20m</div>
          </div>
          <img v-if="form.logo" :src="form.logo" class="avatar" />
        </el-upload>
      </el-form-item>

      <el-form-item label="所属区域" prop="region">
        <el-radio-group v-model="form.region" @change="formChange1">
          <el-radio label="境内">境内</el-radio>
          <el-radio label="境外">境外</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="申请人类型" prop="applicantType">
        <el-radio-group v-model="form.applicantType">
          <el-radio label="国资" v-show="form.region == '境内'">国资</el-radio>
          <el-radio label="非国资">非国资</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="企业类型"  prop="enterpriseType">
        <el-radio-group v-model="form.enterpriseType">
          <el-radio label="国内高校" v-show="form.applicantType == '国资'">
            国内高校
          </el-radio>
          <el-radio label="国内科研院所" v-show="form.applicantType == '国资'">
            国内科研院所
          </el-radio>
          <el-radio label="国有企业" v-show="form.applicantType == '国资'">
            国有企业
          </el-radio>
          <el-radio label="事业单位" v-show="form.applicantType == '国资'">
            事业单位
          </el-radio>

          <el-radio label="民营企业" v-show="form.applicantType == '非国资'">
            民营企业
          </el-radio>
          <el-radio label="外国企业" v-show="form.applicantType == '非国资'">
            外国企业
          </el-radio>
          <el-radio label="港澳台企业" v-show="form.applicantType == '非国资'">
            港澳台企业
          </el-radio>
          <el-radio label="合资企业" v-show="form.applicantType == '非国资'">
            合资企业
          </el-radio>
          <el-radio label="独资企业" v-show="form.applicantType == '非国资'">
            独资企业
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="代理企业" v-show="type == 1">
        <el-select v-model="form.enterpriseId" placeholder="请选择">
          <el-option v-for="(item, index) in enterpriselist" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业名称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="信息代码">
        <el-input v-model="form.code"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-input v-model="form.type"></el-input>
      </el-form-item>
      <el-form-item label="住所">
        <el-input v-model="form.domicile"></el-input>
      </el-form-item>
      <el-form-item label="法定代表人">
        <el-input v-model="form.legalPerson"></el-input>
      </el-form-item>
      <el-form-item label="注册资本">
        <el-input v-model="form.registeredCapital"></el-input>
      </el-form-item>
      <el-form-item label="成立日期">
        <el-input v-model="form.establishTime"></el-input>
      </el-form-item>
      <el-form-item label="营业期限">
        <el-input v-model="form.deadline"></el-input>
      </el-form-item>
      <el-form-item label="经营范围">
        <el-input v-model="form.businessScope"></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input v-model="form.contactPerson"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="form.contactPhone"></el-input>
      </el-form-item>

      <el-form-item :label="form.region == '境外' ? '国家' : '省/市/县(区)'">
        <el-cascader v-model="cascaderValue" :options="options" :props="{ expandTrigger: 'hover' }"
          @change="handleChange"></el-cascader>
      </el-form-item>

      <el-form-item label="电子邮箱">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="通讯地址">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <!-- 代理授权书仅在第三方企业认证出现 -->
      <el-form-item label="代理授权书" v-show="type == 1">
        <el-upload class="upload-demo" :action="burl + '/api/v1/upload'" :on-success="handleAvatarSuccess" multiple
          :limit="1" :on-exceed="handleExceed" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <a href="javascript:;">模板下载</a>
      </el-form-item>
      <el-form-item label="备注信息">
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div class="flex-center ti_jiao" v-if="etype != 1">
      <el-button type="primary" @click="onSubmit('form')" round>提交申请</el-button>
    </div>
    <!-- 展示用表单 -->
    <el-form ref="form" :model="data" :rules="rules" label-width="100px" v-if="etype == 1">
      <el-form-item label="营业执照">
        <el-image style="width: 100px; height: 100px" :src="data.imageUrl" :preview-src-list="[data.imageUrl]">
        </el-image>
      </el-form-item>


      <el-form-item label="企业logo">
        <el-image style="width: 100px; height: 100px" :src="data.logo" :preview-src-list="[data.logo]">
        </el-image>
      </el-form-item>

      <el-form-item label="所属区域">
        <el-input v-model="data.region" disabled></el-input>
      </el-form-item>
      <el-form-item label="申请人类型">
        <el-input v-model="data.applicantType" disabled></el-input>
      </el-form-item>
      <el-form-item label="企业类型">
        <el-input v-model="data.enterpriseType" disabled></el-input>
      </el-form-item>

      <el-form-item label="代理企业" v-show="type == 1">
        <el-select v-model="data.enterpriseId" disabled>
          <el-option v-for="(item, index) in enterpriselist" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业名称">
        <el-input v-model="data.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="信息代码">
        <el-input v-model="data.code" disabled></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-input v-model="data.type" disabled></el-input>
      </el-form-item>
      <el-form-item label="住所">
        <el-input v-model="data.domicile" disabled></el-input>
      </el-form-item>
      <el-form-item label="法定代表人">
        <el-input v-model="data.legalPerson" disabled></el-input>
      </el-form-item>
      <el-form-item label="注册资本">
        <el-input v-model="data.registeredCapital" disabled></el-input>
      </el-form-item>
      <el-form-item label="成立日期">
        <el-input v-model="data.establishTime" disabled></el-input>
      </el-form-item>
      <el-form-item label="营业期限">
        <el-input v-model="data.deadline" disabled></el-input>
      </el-form-item>
      <el-form-item label="经营范围">
        <el-input v-model="data.businessScope" disabled></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名">
        <el-input v-model="data.contactPerson" disabled></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="data.contactPhone" disabled></el-input>
      </el-form-item>

      <el-form-item label="电子邮箱">
        <el-input v-model="data.email" disabled></el-input>
      </el-form-item>

      <el-form-item :label="form.region == '境外' ? '国家' : '省/市/县(区)'">
        <el-input v-model="data.regionName" disabled></el-input>
      </el-form-item>

      <el-form-item label="通讯地址">
        <el-input v-model="data.address" disabled></el-input>
      </el-form-item>

      <!-- 代理授权书仅在第三方企业认证出现 -->
      <el-form-item label="代理授权书" v-show="type == 1">
        <a :href="form.attachment" target="_blank" rel="noopener noreferrer">{{
            form.attachment
        }}</a>
      </el-form-item>
      <el-form-item label="备注信息">
        <el-input type="textarea" v-model="form.remark" disabled></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getRequest, postRequest } from "../api/api";
import { baseUrl } from "../api/constant";
import { options, enOptions } from "../api/region";
export default {
  props: ["data", "type", "etype"],
  data() {
    return {
      form: {
        name: null,
        code: null,
        type: null,
        domicile: null,
        legalPerson: null,
        registeredCapital: null,
        chengli: null,
        deadline: null,
        businessScope: null,
        contactPerson: null,
        contactPhone: null,
        remark: null,
        attachment: null,
        enterpriseId: null,
        imageUrl: null, //营业执照
        region: null,
        applicantType: null,
        enterpriseType: null,
        regionName: null,
        logo: null,
      },
      fileList: [],
      loading: false,
      loading2: false,
      enterpriselist: [],
      cascaderValue: [],
      rules: {
        region: [{ required: true, message: "请选择所属区域" }],
        applicantType: [{ required: true, message: "请选择申请人类型" }],
        enterpriseType: [{ required: true, message: "请选择企业类型" }],
      },
    };
  },
  computed: {
    burl() {
      return baseUrl;
    },
    options() {
      if (this.form.region == "境外") {
        return enOptions;
      } else if (this.form.region == "境内") {
        return options;
      } else {
        return [];
      }
    },
  },
  watch: {
    data() {
      this.dataChange();
    },
  },
  methods: {
    // 清空区域和授权书
    clear() {
      this.fileList = []
      this.cascaderValue = []
    },
    // 触发省/市/县(区)选择切换
    handleChange(n) {
      this.form.regionName = n.join("/");
    },
    // 触发所属区域选择切换
    formChange1(n) {
      this.form.regionName = "";
      if (n == "境外") {
        this.form.applicantType = "非国资";
      }
    },
    dataChange() {
      if (!this.data) {
        this.form = {};
      } else {
        this.form = this.data;
      }
    },
    getEnterprise() {
      let data = {
        page: 0,
        size: 99,
        type: 0,
      };
      getRequest({ url: "/api/v1/auth/enterprise/page", data }).then((res) => {
        if (res.errcode == 200) {
          this.enterpriselist = res.data.filter((item, index) => {
            if (item.status == 1) return item;
          });
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 上传营业执照后的下一步
    next() {
      this.active++;
    },
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {

        let data = this.form;
        if (!data.enterpriseId && this.type == 1) {
          this.$message.error("请选择代理企业");
          return;
        }

        if (this.data?.id) {
          postRequest({
            url: `/api/v1/auth/enterprise/edit/${this.data.id}`,
            data,
          }).then((res) => {
            if (res.errcode == 200) {
              this.$message.success("提交认证成功");
              this.$emit("close");

              this.clear()
            } else {
              this.$message.error(res.errmsg);
            }
          });
        } else {
          postRequest({ url: "/api/v1/auth/enterprise/create", data }).then(
            (res) => {
              if (res.errcode == 200) {
                this.$message.success("提交认证成功");
                this.$emit("close");
              } else {
                this.$message.error(res.errmsg);
              }
            }
          );
        }
      });


    },
    // 上传相关函数---------------------------------------------
    handleAvatarSuccess(res, file) {
      this.form.attachment = res.data.webPath;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    // ---------------------------------------------------------
    // 营业执照上传-------------------------
    handleAvatarSuccess1(cres, file) {
      let data = { path: cres.data.webPath };
      postRequest({ url: "/api/v1/auth/businessLicense", data })
        .then((res) => {
          if (res.errcode == 200) {
            this.loading = false;
            this.form = res.data;
            this.form.imageUrl = cres.data.webPath;
          } else {
            this.loading = false;
            this.$message.error(res.errmsg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    handleProgress() {
      this.loading = true;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 20;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    // ------------------------------------
    // 企业logo上传-------------------------
    handleAvatarSuccess2(res, file) {
      if (res.errcode == 200) {
        this.loading2 = false;
        this.form.logo = res.data.webPath;
      } else {
        this.loading2 = false;
        this.$message.error(res.errmsg);
      }
    },
    handleProgress2() {
      this.loading2 = true;
    },
    beforeAvatarUpload2(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 20;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    // ------------------------------------
  },
  created() {
    this.getEnterprise();
    this.dataChange();
  },
};
</script>

<style lang="scss">
.enterpriseedit {
  padding: 0 10%;

  .el-cascader {
    width: 100%;
  }

  .el-select {
    display: block;
  }

  .el-upload-dragger {
    height: auto;
  }

  .bu_zhou {
    width: 300px;
    margin: 0 auto;
    margin-bottom: 36px;
  }

  .avatar {
    width: 100%;
    height: 100%;
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .jie_guo {
    padding: 24px;
    border: 1px solid rgb(229, 230, 235);
    border-radius: 8px;
    margin-bottom: 24px;

    .biao_ti {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 16px;
    }
  }

  .ti_jiao {
    .el-button.is-round {
      padding: 12px 45px;
    }
  }
}
</style>
